import svgPaths from "./svg-ekwh5y0wx1";

export default function Logo({ className = "w-8 h-8" }: { className?: string }) {
  return (
    <div className={`relative ${className}`} data-name="logo">
      <svg className="absolute block size-full scale-[0.85] origin-center" fill="none" preserveAspectRatio="none" viewBox="0 0 1024 1024">
        <g id="logo">
          <g id="Vector">
            <path d={svgPaths.p31629f80} className="fill-[#2ACD81] dark:fill-[url(#paint0_linear_134_14)]" />
            <path d={svgPaths.p30ef2e80} className="fill-[#2ACD81] dark:fill-[url(#paint1_linear_134_14)]" />
          </g>
          <rect className="fill-[#FF9C2B] dark:fill-[#F1FF2B]" height="90" id="Rectangle 14" rx="8" width="90" x="467.5" y="467" />
        </g>
        <defs>
          <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_134_14" x1="512.5" x2="512.5" y1="157" y2="867">
            <stop stopColor="#55FFF1" />
            <stop offset="0.197731" stopColor="#55FF9C" />
            <stop offset="0.5" stopColor="#CEFF2C" />
            <stop offset="0.854053" stopColor="#55FF9C" />
            <stop offset="1" stopColor="#55FFF1" />
          </linearGradient>
          <linearGradient gradientUnits="userSpaceOnUse" id="paint1_linear_134_14" x1="512.5" x2="512.5" y1="157" y2="867">
            <stop stopColor="#55FFF1" />
            <stop offset="0.197731" stopColor="#55FF9C" />
            <stop offset="0.5" stopColor="#CEFF2C" />
            <stop offset="0.854053" stopColor="#55FF9C" />
            <stop offset="1" stopColor="#55FFF1" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}